"use strict";
class Invariantor {
    constructor(categoryTreeToEnsure) {
        this.categoryTree = categoryTreeToEnsure;
    }
    ensureId() {
        if (this.categoryTree.organization) {
            this.categoryTree.id = `ProductCategoryTree-${this.categoryTree.organization.id}`;
        }
        return this;
    }
    value() {
        return { ...this.categoryTree };
    }
}
module.exports = entity => {
    const ensured = new Invariantor(entity).ensureId().value();
    return ensured;
};
